// src/components/SearchBar/SearchBar.ts
import { SearchService } from '../../services/SearchService';
import { SearchSuggestion } from '../../types';

export function searchBar(searchService: SearchService) {
  return {
    searchQuery: '',
    suggestions: [] as SearchSuggestion[],
    showDropdown: false,
    loading: false,
    searchTimeout: null as number | null,

    async handleInput() {
      if (this.searchQuery.length < 2) {
        this.showDropdown = false;
        this.suggestions = [];
        return;
      }

      // Track search if on prod
      if (window.location.origin === 'meatscroller.com' && 'umami' in window) {
        (window as any).umami.track('search', {
          searchTerm: this.searchQuery
        });
      }

      // Debounce the search
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      this.showDropdown = true;
      this.loading = true;

      this.searchTimeout = setTimeout(async () => {
        try {
          this.suggestions = await searchService.searchSubreddits(this.searchQuery);
        } catch (error) {
          console.error('Error fetching suggestions:', error);
          this.suggestions = [];
        } finally {
          this.loading = false;
        }
      }, 300);
    },

    closeDropdown() {
      this.showDropdown = false;
    },

    initSearchBar(sub: string) {
      searchService.init();
      if (sub) {
        this.searchQuery = sub;
      }
    },

  };
}
